module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-4.6a893d28.jpg";